import React from 'react';
import clsx from 'clsx';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import inputStyles from 'components/UI/V3/Forms/Input/Input.module.scss';
import { PROMO_CODE_NAME_MAX_LENGTH } from './hooks/usePromoCodeDetailsStep';

interface PromoCodeNameFieldProps {
    value: string;
    error?: string;
    disabled?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromoCodeNameField: React.FC<PromoCodeNameFieldProps> = ({ value, error, disabled, onChange }) => {
    return (
        <div className={inputStyles.root}>
            <Label
                required={true}
                error={error}
            >
                Promo Code
            </Label>
            <div className={inputStyles.inputWrapper}>
                <input
                    className={clsx(inputStyles.input, {
                        [inputStyles.inputError]: !!error,
                        [inputStyles.inputFilled]: value.length > 0
                    })}
                    placeholder="Ex. SALE25"
                    value={value}
                    maxLength={PROMO_CODE_NAME_MAX_LENGTH}
                    disabled={disabled}
                    autoComplete="off"
                    spellCheck={false}
                    autoFocus={true}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};
